import { message, Space } from "antd";
import axios from "axios";
import PropTypes from "prop-types";
import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory, useRouteMatch } from "react-router";
import ActionBar from "../../../components/action-bar";
import ActionButton from "../../../components/action-button";
import MiniTable from "../../../components/mini-table";
import { Alerta } from "../../../constants";
import useDispatchWithResult from "../../../hooks/useDispatchWithResult";
import useLoading from "../../../hooks/useLoading";
import {
  contratosAlertaNivelSelector,
  contratosAlertasSelector,
  contratosOrgaoSelector,
  contratosSearchSelector,
  contratosSelector,
  fetchContratos,
  fetchLivrosDigitais,
  fetchVerificarLimite,
  isEditableSelector,
} from "../../../store/empresa";
import unwrapAxiosPromise from "../../../util/unwrapAxiosPromise";
import { openPopup } from "../../../util/window";
import Alertas from "../_Alertas";
import styles from "../_styles.less";
import EmpresaContratosTable from "./_table";
import useModulo from "../../../hooks/useModulo";
import SelectEmpresaContratoOrgao from "../../../components/select-empresa-contrato-orgao";

export default function EmpresaContratosDetailPage() {
  const miniTableRef = useRef();
  const { t } = useTranslation();
  const dispatch = useDispatchWithResult();
  const nivel = useSelector(contratosAlertaNivelSelector);
  const isEditable = useSelector(isEditableSelector);
  const contratos = useSelector(contratosSelector);
  const orgao = useSelector(contratosOrgaoSelector);
  const search = useSelector(contratosSearchSelector);
  const alertas = useSelector(contratosAlertasSelector);
  const loading = useLoading(fetchContratos.typePrefix);
  const history = useHistory();
  const match = useRouteMatch();
  const empresaId = match.params.empresaId;
  const { moduloBasePath } = useModulo();
  const [loadingRemove, setLoadingRemove] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);

  const isNA =
    nivel === Alerta.Nivel.NA.id || nivel === Alerta.Nivel.inativo.id;

  const handleOrgaoChange = (orgao) => {
    dispatch(fetchContratos({ empresaId, orgao }));
  };

  const handleSearch = (search) => {
    dispatch(fetchContratos({ empresaId, search }));
  };

  const handleCreate = () => {
    unwrapAxiosPromise(dispatch(fetchVerificarLimite()))
    .then(() => {
    history.replace(`${moduloBasePath}/empresas/${empresaId}/contratos/create`);
    })
  };

  const handleRemove = () => {
    setLoadingRemove(true);
    unwrapAxiosPromise(
      axios.delete(`/empresas/${empresaId}/contratos`, {
        params: { ids: selectedIds },
      })
    )
      .then(() => {
        message.success(t("Registro(s) removido(s) com sucesso"));
        setSelectedIds([]);
        dispatch(fetchContratos({ empresaId }));
        dispatch(fetchLivrosDigitais({ empresaId }));
      })
      .finally(() => setLoadingRemove(false));
  };

  const handleDetail = (contrato) => {
    history.replace(
      `${moduloBasePath}/empresas/${empresaId}/contratos/${contrato.id}`
    );
  };

  const handleLogs = () => {
    openPopup(
      `/logs?categoria=/empresas/${empresaId}/contratos/`,
      `logs_/empresas/${empresaId}/contratos/`
    );
  };

  const actions = [];
  if (isEditable) {
    actions.push(
      <ActionButton.Create disabled={isNA} onClick={handleCreate} />
    );
    actions.push(
      <ActionButton.Remove
        disabled={selectedIds.length === 0 || isNA}
        onClick={handleRemove}
        loading={loadingRemove}
      />
    );
  }
  actions.push(<ActionButton.Logs noTitle onClick={handleLogs} />);
  actions.push(
    <MiniTable.DownloadButton
      disabled={loading || contratos.length === 0}
      miniTableRef={miniTableRef}
    />
  );
  const title = () => (
    <ActionBar
      leftActions={[
        <SelectEmpresaContratoOrgao
          allowClear
          placeholder={t("Órgão")}
          style={{ minWidth: 200 }}
          value={orgao}
          onChange={handleOrgaoChange}
        />,
      ]}
      search={search}
      onSearch={handleSearch}
    >
      {actions}
    </ActionBar>
  );
  return (
    <Space direction="vertical" className={styles["space-2"]}>
      <EmpresaContratosTable
        dataSource={contratos}
        loading={loading}
        miniTableRef={miniTableRef}
        onClick={handleDetail}
        onSelectedIdsChange={setSelectedIds}
        selectedIds={selectedIds}
        title={title}
      />
      <Alertas alertas={alertas} />
    </Space>
  );
}

EmpresaContratosDetailPage.propTypes = {
  contratos: PropTypes.array,
  onCreate: PropTypes.func,
  onRemove: PropTypes.func,
};
